import { useTranslation } from 'react-i18next';

import { Button, ButtonProps } from '@pletly/ui';
import ImageIcon from '%assets/icons/image.svg';

type Props = Pick<ButtonProps, 'style' | 'onPress' | 'disabled' | 'accessoryLeft' | 'testID'> & {
	children?: ButtonProps['children'];
};

export const AddNewButton = ({
	testID = 'add-media-button',
	style,
	onPress,
	disabled,
	children,
	accessoryLeft = <ImageIcon />,
}: Props) => {
	const { t } = useTranslation();

	return (
		<Button
			testID={testID}
			color="basic"
			variant="filled"
			size="small"
			accessoryLeft={accessoryLeft}
			style={style}
			onPress={onPress}
			disabled={disabled}
		>
			{children ?? t('post.add-media')}
		</Button>
	);
};
